export default __webpack_public_path__ + "static/media/Staged_Screenshot.40d6e0fc.png";